import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const TranslationContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  flex-direction: column;
  margin-bottom: ${props => props.theme.spacing.sp8};
`
export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
